import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ItemDateCard from "~business/Cards/ItemDateCard";
import DetalleCard from "~business/Cards/DetalleCard";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { DateRange } from "~api/types";
import {
  getAnulaciones,
  setFechaDesdeAnulaciones,
  setFechaHastaAnulaciones,
  GetAnulacionesState,
} from "./actions";
import { FechaField } from "../types";

const useReduxSelector = () =>
  useSelector<any, GetAnulacionesState>((state) => ({
    ...state.getAnulacionesReducer,
  }));

const AnulacionesCard: React.FC = () => {
  const dispatch = useDispatch();
  const {
    fechaDesdeAnulacionesSelected,
    fechaHastaAnulacionesSelected,
    buttonEnabled,
    buttonText,
  } = useReduxSelector();

  const handleChangeFechaDesdeAnulaciones = (
    fechaDesdeAnulaciones: FechaField
  ) => {
    dispatch(setFechaDesdeAnulaciones(fechaDesdeAnulaciones));
  };
  const handleChangeFechaHastaAnulaciones = (
    fechaHastaAnulaciones: FechaField
  ) => {
    dispatch(setFechaHastaAnulaciones(fechaHastaAnulaciones));
  };
  const handleGetAnulaciones = () => {
    // ItemDateCard deja en value lo que le llega (Date, texto o null); el API
    // los formatea con date-fns como hasta ahora.
    const data: DateRange = {
      fechaDesde: fechaDesdeAnulacionesSelected.value as Date,
      fechaHasta: fechaHastaAnulacionesSelected.value as Date,
    };
    dispatch(getAnulaciones(data) as any);
  };

  return (
    <>
      <DetalleCard title={"Anulaciones"}>
        <ItemDateCard
          label="Desde"
          value={fechaDesdeAnulacionesSelected.value}
          onChange={handleChangeFechaDesdeAnulaciones}
        />
        <ItemDateCard
          label="Hasta"
          value={fechaHastaAnulacionesSelected.value}
          onChange={handleChangeFechaHastaAnulaciones}
        />
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetAnulaciones}
                disabled={!buttonEnabled}
              >
                {buttonText}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DetalleCard>
    </>
  );
};

export default AnulacionesCard;
